import { inject }          from '@angular/core';
import {
  CanActivateFn,
  Router,
}                          from '@angular/router';
import { AuthService }     from '@auth0/auth0-angular';
import { Store }           from '@ngrx/store';
import {
  map,
  take,
}                          from 'rxjs';
import { ENVIRONMENT }     from '../app.constants';
import { logoutCompleted } from '../state/app.actions';

export const loggedOutGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const store = inject(Store);
  const environment = inject(ENVIRONMENT);

  const officeId = state.root.queryParamMap.get('officeId');

  return authService.isAuthenticated$.pipe(
    take(1),
    map(isAuthenticated => {
      const canActivate = !isAuthenticated || !!officeId;
      if (canActivate) {
        store.dispatch(logoutCompleted());
      } else {
        router.navigate(['/']).then();
      }
      if (officeId) {
        window.location.assign(`${environment.admin}/offices/${officeId}/detail`);
      }
      return canActivate;
    }),
  );
};
